import React from 'react';
// import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
// import { isMobile } from 'react-device-detect';
import { Divider } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    card: {
      maxWidth: 270,
      //minHeight: 200
    },
    cardMobile: {
      maxWidth: 200,
      // width: '100%',
      // height: 110
    },
    logo: {
      [theme.breakpoints.up('xs')]: {
        width: '30%',
        paddingLeft: '40px'
      },
      [theme.breakpoints.up('sm')]: {
          width: `30%`,
          paddingLeft: '40px'
      },
      [theme.breakpoints.up('md')]: {
          width: `30%`,
          paddingLeft: '40px'
      },
      [theme.breakpoints.up('lg')]: {
          width: `30%`,
          paddingLeft: '40px'
      },
      [theme.breakpoints.up('xl')]: {
          width: `30%`,
          paddingLeft: '40px'
      },
      },
  }));

const MenuHeader = props => {
    const classes = useStyles();
    return (
        <Card elevation={0} className={classes.card} style={{backgroundColor: '#008c9a', borderColor: 'white'}}>
            <CardActionArea style={{ width: '500px', height: '100px', borderColor: 'white'}}>
                  <img src={process.env.PUBLIC_URL + '/images/logo_voucher.png'} alt="Logo" className={classes.logo}  />
            </CardActionArea>
            <Divider component="li" style={{backgroundColor: '#FFFFFF'}}/>
        </Card>
    );
};

MenuHeader.propTypes = {
    
};

export default MenuHeader;